import { render } from "./UiToastList.vue?vue&type=template&id=8c1117dc&scoped=true"
import script from "./UiToastList.vue?vue&type=script&lang=js"
export * from "./UiToastList.vue?vue&type=script&lang=js"

import "./UiToastList.vue?vue&type=style&index=0&id=8c1117dc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c1117dc"]])

export default __exports__